import { Component, OnInit } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-export-industry',
  templateUrl: './export-industry.component.html',
  styleUrls: ['./export-industry.component.css']
})
export class ExportIndustryComponent implements OnInit {

  uploadButton:string = 'Upload';
  route:string;
  addVendorLoader = false;
  error:boolean=false;
  success:boolean=false;
  errorMessage:string='';
  successMessage:string='';
  selectedFile : FileList;
  resetSelectedFile : FileList;
  data = [];
  uploadIndustryLoader = false;
  vendorList = [];
  selectedVendor = '';

  user_id = '';
  password = '';

  selectedView = 'export';
  selectedTitle = 'Import Industry';

  vendorToken = '';
  vendorFullName = '';
  formErrorVendorCompleteName = '';
  VendorError = false;
  shortName = '';
  formErrorVendorShortName = '';
  vendorSuccess = false;

  constructor(private router: Router,
              private _service: CommonService) { }

  ngOnInit() {
    this.getVendorList();
  }


  getVendorList(){

    this.route  = 'get-vendor-list';
    const token = localStorage.getItem('userToken');
    let data = {};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.vendorList = response.data;
      }
    });

  }

  public saveData(csvData:any){

    this.route  = 'export-industry';
    const formData = new FormData();
    formData.append('csvData',csvData,csvData.name);
    formData.append('vendor',this.selectedVendor);
    
    const token    = localStorage.getItem('userToken');
    this._service.postRequestCreator(formData, this.route, token)
        .subscribe((response) => {

          if(response['status'] == 'success'){
            this.success = true;
            this.successMessage = 'File uploaded successfully';
            this.uploadButton = 'Upload';
            this.error = false;
            this.errorMessage = '';
            this.selectedVendor = '';

            // let element: HTMLElement =  document.getElementById('selectedIndustryMetadata') as HTMLElement;
            // element.click();

          }else{
            this.error = true;
            this.success = false;
            this.errorMessage = 'Something went wrong while uploading file / invalid format / invalid data';
            this.uploadButton = 'Upload';
          }
          this.uploadIndustryLoader = false;
        });

  }

  switchView(selection){

    this.selectedView = selection;
    this.vendorSuccess = false;
    this.vendorToken = '';

    if(selection == 'export'){
      this.getVendorList();
      this.selectedTitle = 'Import Industry';
    }else{
      this.selectedTitle = 'Add Vendor';
    }
  }

  addVendor(){

    this.VendorError = false;
    this.vendorSuccess = false;
    this.vendorToken= '';

    if(this.vendorFullName.trim()){
      this.formErrorVendorCompleteName = '';
    }else{
      this.formErrorVendorCompleteName = 'Please enter Vendor Name';
      this.VendorError = true;
    }

    if(this.shortName.trim()){
      this.formErrorVendorShortName = '';
    }else{
      this.formErrorVendorShortName = 'Please enter Vendor Name';
      this.VendorError = true;
    }

    if(!this.VendorError){
      this.addVendorLoader = true;
      this.route  = 'add-new-vendor';
      const token = localStorage.getItem('userToken');
      let data = {
        'vendorName':this.vendorFullName,
        'shortName':this.shortName
      };

      this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

        if(response.status == 204) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('userData');
          this.router.navigate(['login']);
        }

        if(response.status == 200){

          this.vendorSuccess = true;

          this.vendorToken = response.data.token;
          this.user_id = response.data.user_id;
          this.password = response.data.password;
          this.vendorFullName = '';
          this.formErrorVendorCompleteName = '';
          this.VendorError = false;
          this.shortName = '';
          this.formErrorVendorShortName = '';

          Swal('Success', 'Vendor Added Successfully<br/> Token: '+this.vendorToken, 'success');
        }else{
          Swal('Oops...', 'Something went wrong!', 'error');
        }

        this.addVendorLoader = false;
      });

    }

  }

  public changeListener(files: FileList){

    this.success = false;
    this.error = false;
    this.successMessage = '';
    this.errorMessage = '';
    this.selectedFile = files;
  }

  public uploadListener(){

    this.uploadIndustryLoader = true;

    this.uploadButton = 'Uploading';
    this.success = false;
    this.error = false;
    this.successMessage = '';
    this.errorMessage = '';

    if(!this.selectedVendor.trim()){
      this.uploadButton = 'Upload';
      this.error = true;
      this.errorMessage = 'Please select vendor.';
      this.uploadIndustryLoader = false;
      return;
    }

    if(this.selectedFile && this.selectedFile.length > 0) {
      let file : File = this.selectedFile.item(0);

      let size : number = file.size;

      console.log(file);
      console.log(file.type);

      let extension = '';

      if(file.type){
        extension = file.type;
      }else{
        if (file.name.length != 0) {
          var dot = file.name.lastIndexOf(".");
          if (dot != -1) {
            extension = file.name.substr(dot, file.name.length);
          }
        }
      }

      if(extension && (extension == 'text/csv' || extension == '.csv' || extension == 'application/vnd.ms-excel' || extension == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
        if((size/1000)/1000 <= 10){

          let reader: FileReader = new FileReader();
          reader.readAsText(file);
          reader.onload = (e) => {
            this.saveData(file);
          }
        }else{
          this.uploadIndustryLoader = false;
          this.uploadButton = 'Upload';
          this.error = true;
          this.errorMessage = 'Max file size is 10 MB.';
        }
      }else{
        this.uploadIndustryLoader = false;
        this.uploadButton = 'Upload';
        this.error = true;
        this.errorMessage = 'Only CSV file accepted';
      }

    }else{
      this.uploadButton = 'Upload';
      this.error = true;
      this.errorMessage = 'Invalid File';
      this.uploadIndustryLoader = false;
    }
  }

}
